import React, { useEffect, useRef } from 'react';
import {
  AdvTitleNavRow,
  AdvTitle,
  NavWithButtonsWrapper,
  NavScrollWrapper,
  AdvNavBar,
  AdvNavButton,
  ButtonWrapper,
  ScrollArrowLeft,
  ScrollArrowRight
} from './styled';
import type { TitleAndFiltersProps } from '../../types';

const TitleAndFilters: React.FC<TitleAndFiltersProps> = ({
  title,
  placements,
  activeIdx,
  onPick,
  showLeft,
  showRight,
  scrollNav,
  navBarWrapperRef,
  isSmall
}) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!isSmall) return;
    const container = navBarWrapperRef.current;
    if (!container) return;
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    const maxLeft = container.scrollWidth - container.clientWidth;
    if (maxLeft <= 0) return;
    const btn = container.querySelector<HTMLButtonElement>(
      `button[data-idx="${activeIdx}"]`
    );
    if (!btn) return;
    let targetLeft =
      btn.offsetLeft - container.clientWidth / 2 + btn.clientWidth / 2;
    if (targetLeft < 0) targetLeft = 0;
    if (targetLeft > maxLeft) targetLeft = maxLeft;

    container.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }, [activeIdx, isSmall, navBarWrapperRef]);

  return (
    <AdvTitleNavRow>
      <AdvTitle>{title}</AdvTitle>
      <NavWithButtonsWrapper>
        <NavScrollWrapper ref={navBarWrapperRef}>
          <AdvNavBar>
            {placements.map((p, idx) => (
              <AdvNavButton
                key={p.name}
                active={idx === activeIdx}
                onClick={() => onPick?.(idx)}
                data-cy={`adv-nav-btn-${idx}`}
                data-stat="advantage-block-jk"
                data-idx={idx}
              >
                {p.name}
              </AdvNavButton>
            ))}
          </AdvNavBar>
        </NavScrollWrapper>
        <ButtonWrapper>
          {showLeft && (
            <ScrollArrowLeft
              onClick={() => scrollNav('left')}
              aria-label="scroll left"
            />
          )}
          {showRight && (
            <ScrollArrowRight
              right
              onClick={() => scrollNav('right')}
              aria-label="scroll right"
            />
          )}
        </ButtonWrapper>
      </NavWithButtonsWrapper>
    </AdvTitleNavRow>
  );
};

export default TitleAndFilters;
